export enum FireBatchStatus {
  GENERATED = 'GENERATED',
  PENDING = 'PENDING',
  CANCELLED = 'CANCELLED',
  ON_APPROVAL = 'ON_APPROVAL',
  REJECTED = 'REJECTED',
  READY_FOR_PROCESSING = 'READY_FOR_PROCESSING',
  COMPLETE = 'COMPLETE',
  ARCHIVED = 'ARCHIVED'
}

export enum FireBatchStatusCategory {
  pending = 'pending',
  toBeApproved = 'toBeApproved',
  rejected = 'rejected',
  complete = 'complete',
  archived = 'archived'
}

export const FireBatchStatusCategoryMapping = {
  pending: [FireBatchStatus.GENERATED, FireBatchStatus.PENDING],
  toBeApproved: [
    FireBatchStatus.ON_APPROVAL,
    FireBatchStatus.READY_FOR_PROCESSING
  ],
  rejected: [FireBatchStatus.CANCELLED, FireBatchStatus.REJECTED],
  complete: [FireBatchStatus.COMPLETE],
  archived: [FireBatchStatus.ARCHIVED]
};

export type FireBatchStatusCategoryTotals = {
  [key in FireBatchStatusCategory]: number;
};
